// Copyright (c) 2026 Endel Dreyer.
//
// This software is released under the MIT License.
// https://opensource.org/license/MIT
//
// colyseus.js@0.17.42
/**
 * Minimal fetch-compatible wrapper around XMLHttpRequest.
 * Used as an automatic fallback when globalThis.fetch is unavailable
 * (e.g. Cocos Creator Native).
 */
function xhrFetch(url, init) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const method = init?.method || "GET";
        xhr.open(method, url.toString());
        xhr.withCredentials = (init?.credentials === "include");
        // Apply request headers
        if (init?.headers) {
            const headers = (init.headers instanceof Headers)
                ? init.headers
                : new Headers(init.headers);
            headers.forEach((value, key) => {
                xhr.setRequestHeader(key, value);
            });
        }
        xhr.onload = () => {
            // Parse response headers
            const headers = new Headers();
            const rawHeaders = xhr.getAllResponseHeaders().trim();
            if (rawHeaders) {
                for (const line of rawHeaders.split(/[\r\n]+/)) {
                    const idx = line.indexOf(": ");
                    if (idx > 0) {
                        headers.append(line.substring(0, idx), line.substring(idx + 2));
                    }
                }
            }
            const responseBody = xhr.response ?? xhr.responseText;
            resolve(new XHRResponse(responseBody, {
                status: xhr.status,
                statusText: xhr.statusText,
                headers,
            }));
        };
        xhr.onerror = () => reject(new TypeError("Network request failed"));
        xhr.ontimeout = () => reject(new TypeError("Network request timed out"));
        xhr.send(init?.body ?? null);
    });
}
/**
 * Minimal Response-compatible class backed by XHR response data.
 * Implements only the surface used by HTTP.executeRequest().
 */
class XHRResponse {
    status;
    statusText;
    headers;
    ok;
    body;
    constructor(body, init) {
        this.body = body;
        this.status = init.status;
        this.statusText = init.statusText;
        this.headers = init.headers;
        this.ok = init.status >= 200 && init.status < 300;
    }
    async json() {
        return typeof this.body === "string"
            ? JSON.parse(this.body)
            : this.body;
    }
    async text() {
        return typeof this.body === "string"
            ? this.body
            : JSON.stringify(this.body);
    }
    async blob() {
        return new Blob([this.body]);
    }
}

export { xhrFetch };
//# sourceMappingURL=fetchXHR.mjs.map
